export default __webpack_public_path__ + "static/media/josheverett.4212b9ed.png";